var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-smart-slider-marks" },
    _vm._l(_vm.propMarks, function (mark) {
      return _c("vue-smart-slider-mark", {
        key: mark.id,
        attrs: {
          "prop-mark": mark,
          "prop-width": _vm.propWidth,
          "prop-max": _vm.propMax,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }